import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';

export const AddressFileRenameModal = () => {
  const { closeModal } = useModalMethods(Modals.AddressFileRename);
  const { modalProps } = useModalState(Modals.AddressFileRename);

  const [baseName, setBaseName] = useState('');
  const [extension, setExtension] = useState('');

  useEffect(() => {
    const fallback = modalProps?.fileName ?? '';
    const dotIndex = fallback.lastIndexOf('.');
    setBaseName(dotIndex !== -1 ? fallback.slice(0, dotIndex) : fallback);
    setExtension(dotIndex !== -1 ? fallback.slice(dotIndex) : '');
  }, [modalProps?.fileName]);

  const handleSubmit = () => {
    modalProps?.onRename?.(baseName.trim() + extension);
    closeModal();
  };

  const nameChanged =
    baseName.trim() !== '' &&
    modalProps?.fileName &&
    baseName.trim() + extension !== modalProps?.fileName;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && nameChanged) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Dialog open onClose={closeModal} fullWidth>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderColor: (theme) => theme.palette.custom.OV.sys.outlineVariant,
          px: 3,
        }}
      >
        <Typography>Rename file</Typography>
      </DialogTitle>
      <DialogContent sx={{ py: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <TextField
            autoFocus
            fullWidth
            size="small"
            variant="standard"
            value={baseName}
            onChange={(e) => setBaseName(e.target.value)}
            inputProps={{ maxLength: 255 }}
            onKeyDown={handleKeyDown}
          />
          <Typography
            sx={{
              ml: 1,
              whiteSpace: 'nowrap',
              color: 'text.secondary',
              fontSize: '1rem',
              mt: 3.5,
              pb: '1rem',
            }}
          >
            {extension}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2,
        }}
      >
        <Button onClick={closeModal}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!nameChanged}>
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
};
